/**
 * ============================================================
 * KEJJA OS — src/hooks/useHomes.ts
 * Mutations for home CRUD.
 * ============================================================
 */

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api, type KejjaHome } from '@/lib/api';

export interface CreateHomeInput {
  name: string;
  motto?: string;
  country: string;
  region?: string;
  currencyCode: string;
  timezone: string;
}

export function useCreateHome() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (input: CreateHomeInput) => {
      return api.post<KejjaHome>('/homes', input);
    },
    onSuccess: () => {
      // Invalidate caches so dashboard refreshes with the new home
      queryClient.invalidateQueries({ queryKey: ['me', 'homes'] });
      queryClient.invalidateQueries({ queryKey: ['me'] });
    },
  });
}
